import { Datadog } from "@magalu/ecomm-components";
import useClientEnv from "@magalu/rave/config/useClientEnv";

import packageJson from "../../package.json";

type Environment = "development" | "staging" | "production";

export default function DatadogInit() {
  const { client } = useClientEnv<{ environment: Environment }>();

  const environment = client.environment;

  if (environment === "development") {
    return null;
  }

  return (
    <Datadog
      applicationId="ebdcd394-ea53-457c-8daf-5659efb01d31"
      clientToken="pub65a718f902aee0ef33f464f14d53b149"
      datadogUrl="us5.datadoghq.com"
      service="mixer-hybrid"
      env={environment}
      version={`v${packageJson.version}`}
      sessionSampleRate={10}
      sessionReplaySampleRate={1}
      serviceDomainUrl="https://mixer-hybrid.magazineluiza.com.br"
      strategy="beforeInteractive"
      defaultPrivacyLevel="mask-user-input"
      trackLongTasks
      trackResources
      trackUserInteractions
    />
  );
}
